// Backend configuration
export const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:3003';
export const WS_BASE_URL = process.env.REACT_APP_WS_URL || 'ws://localhost:3003';

// Get WebSocket URL (supports both ws and wss)
export const getWebSocketUrl = () => {
  if (process.env.REACT_APP_WS_URL) {
    return process.env.REACT_APP_WS_URL;
  }
  
  // Default to localhost:3003 for development
  const protocol = window.location.protocol === 'https:' ? 'wss:' : 'ws:';
  return `${protocol}//localhost:3003`;
};

